var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtitleActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/subtitle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "subtitle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4917 1.66663H6.50835C3.47502 1.66663 1.66669 3.47496 1.66669 6.50829V13.4833C1.66669 16.525 3.47502 18.3333 6.50835 18.3333H13.4834C16.5167 18.3333 18.325 16.525 18.325 13.4916V6.50829C18.3334 3.47496 16.525 1.66663 13.4917 1.66663ZM5.41669 10.475H7.72502C8.06669 10.475 8.35002 10.7583 8.35002 11.1C8.35002 11.4416 8.06669 11.725 7.72502 11.725H5.41669C5.07502 11.725 4.79169 11.4416 4.79169 11.1C4.79169 10.7583 5.07502 10.475 5.41669 10.475ZM10.8084 14.8583H5.41669C5.07502 14.8583 4.79169 14.575 4.79169 14.2333C4.79169 13.8916 5.07502 13.6083 5.41669 13.6083H10.8084C11.15 13.6083 11.4334 13.8916 11.4334 14.2333C11.4334 14.575 11.1584 14.8583 10.8084 14.8583ZM14.5834 14.8583H13.0417C12.7 14.8583 12.4167 14.575 12.4167 14.2333C12.4167 13.8916 12.7 13.6083 13.0417 13.6083H14.5834C14.925 13.6083 15.2084 13.8916 15.2084 14.2333C15.2084 14.575 14.925 14.8583 14.5834 14.8583ZM14.5834 11.725H9.97502C9.63335 11.725 9.35002 11.4416 9.35002 11.1C9.35002 10.7583 9.63335 10.475 9.97502 10.475H14.5834C14.925 10.475 15.2084 10.7583 15.2084 11.1C15.2084 11.4416 14.925 11.725 14.5834 11.725Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtitleActive);
export default __webpack_public_path__ + "static/media/subtitle-active.e7a3221c1c290b260f0a3060155a4c4b.svg";
export { ForwardRef as ReactComponent };